import { tagAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { get } from 'lodash'
import { transparentize } from 'polished'

// eslint-disable-next-line @typescript-eslint/unbound-method
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tagAnatomy.keys
)

export const Tag = defineMultiStyleConfig({
  variants: {
    metabaseFilter: {
      container: {
        px: 2,
        py: 1,
        borderRadius: 'base',
        bg: '#E5E3ED',
        color: '#7C72A4',
      },
    },
    filter: ({ colorScheme }) => ({
      container: {
        px: 2,
        py: 1,
        borderRadius: 'base',
        bg: `${colorScheme}.50`,
        color: 'product.text.dark.bodySolid',
      },
    }),
    employeeStatus: {
      container: {
        px: 2,
        py: 0.5,
        borderRadius: 'base',
        fontSize: 11,
        lineHeight: '4',
        minH: 'unset',
      },
    },
    product: ({ colorScheme }) => {
      return {
        container: {
          fontFamily: 'Lato',
          color: 'product.text.dark.bodySolid',
          background: `product.${colorScheme}.100`,
          borderWidth: 1,
          borderColor: `product.${colorScheme}.200`,
        },
      }
    },
    solidAlpha10: ({ colorScheme, theme }) => {
      const color: string = get(theme, `colors.${colorScheme}.500`)
      return {
        container: {
          color,
          background: transparentize(0.9, color),
        },
      }
    },
  },
  sizes: {
    sm: {
      container: {
        px: 1,
        py: '1px',
        borderRadius: 'sm',
      },
    },
  },
})
